import type { Xinglet } from '@xing-com/crate-xinglet';
import { useLoginAppUrl } from '@xing-com/crate-xinglet';
import { LoggedoutView } from '@xing-com/platform-layout-logged-out';

import { BlankWithFooterLayout } from './blank-with-footer';

type Props = {
  isGridless: boolean;
  layout: string;
  children: React.ReactNode;
};

export default class LoggedoutLayouts implements Xinglet {
  public getComponent(): React.FC<Props> {
    return ({ isGridless, layout, children }): JSX.Element => {
      const loginAppUrl = useLoginAppUrl();

      if (layout === 'blank-with-footer') {
        return (
          <BlankWithFooterLayout loginLink={loginAppUrl}>
            {children}
          </BlankWithFooterLayout>
        );
      }

      return (
        <LoggedoutView
          type="standard"
          gridless={isGridless}
          loginLink={loginAppUrl}
        >
          {children}
        </LoggedoutView>
      );
    };
  }
}
